import { Box, Card } from "@chakra-ui/react";

import Footer from "@/components/Footer";
import { SUBSCRIPTION_TABLE_COLUMNS } from "@/config/tables";
import { useTableFiltersCursor } from "@/hooks/useTableFiltersCursor";
import Filters from "./Filters";
import { useFetchSubscriptions } from "../hooks/useFetchSubscriptions";
import { FiltersType } from "../types/filters.type";
import { Table as ChakraTable } from "@chakra-ui/react";
import GenericTable from "@/components/GenericTable";
import GenericTableElement from "@/components/GenericTableElement";
import { Subscription } from "@/types/types";

const TABLE_KEY = "subscriptions";

export default function ActiveSubscriptionsTable() {
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<FiltersType>(TABLE_KEY);
  const { subscriptions, nextCursor, isLoading } = useFetchSubscriptions(
    queryFilters,
    cursor
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="1.5rem"
      flex="1"
      minH={0}
    >
      <Card.Root
        borderRadius="lg"
        border="none"
        display="flex"
        flexDirection="column"
        gap="1rem"
        flexShrink={0}
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p="4">
          <Filters
            queryFilters={queryFilters}
            setQueryFilters={setQueryFilters}
          />
        </Card.Body>
      </Card.Root>
      <GenericTable
        isLoading={isLoading}
        columns={SUBSCRIPTION_TABLE_COLUMNS}
        fillHeight
      >
        {subscriptions.map((subscription, index) => (
          <ChakraTable.Row key={index}>
            {SUBSCRIPTION_TABLE_COLUMNS.map((column) => (
              <GenericTableElement
                key={`${index}-${column.key}`}
                value={subscription[column.key as keyof Subscription]}
                formatDatetimeUtc={column.key === "subscriptionSince"}
              />
            ))}
          </ChakraTable.Row>
        ))}
      </GenericTable>
      <Footer
        tableProps={{
          fileName: "suscripciones",
          items: subscriptions,
          columns: SUBSCRIPTION_TABLE_COLUMNS,
          pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
        }}
      />
    </Box>
  );
}
